module.exports = __webpack_public_path__ + "static/media/fish.fb32827f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/fish.svg
// module id = 64
// module chunks = 0